








import { computed, defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";

export default defineComponent({
  name: "UserBackground",
  props: {
    user: { type: Object as PropType<UserPublicData>, required: true },
    forceNsfw: { type: Boolean, default: false },
    blurred: { type: Boolean, default: false },
  },
  setup(props) {
    const src = computed(() => {
      const background = props.user ? props.user[props.forceNsfw ? "backgroundNsfw" : "background"] : null;
      return background ? MediaFilesController.getImageThumbnail(background.urlPart, "1080p") : "";
    });
    return {
      src,
    };
  },
});
